import { FC, useState } from 'react'
import { Container } from '../video/styled'
import { PlayIcon } from '../video/play-icon'

type Props = {
  id: string
  localhost?: string
  poster: string
  isCollapsed?: boolean
  onPlay?: () => void
}

export const VideoCMS: FC<Props> = ({
  id,
  localhost,
  poster,
  onPlay,
  isCollapsed = false,
}) => {
  const [isVisible, setVisible] = useState(false)
  const handleClick = () => {
    setVisible(true)
    if (onPlay) {
      onPlay()
    }
  }
  if (!localhost) {
    localhost = 'https://currenttime.tv'
  }
  return (
    <Container $isCollapsed={isCollapsed}>
      {isVisible ? (
        <iframe
          src={`${localhost}/embed/player/article/${id}.html`}
          scrolling="no"
          frameBorder="0"
          width="640"
          height="363"
          allowFullScreen
        ></iframe>
      ) : (
        <button onClick={handleClick}>
          <img src={poster} alt="" />
          <PlayIcon />
        </button>
      )}
    </Container>
  )
}
